import React, { useState } from "react";
import { Link } from "react-router-dom";
import DashboardChart from "../../components/common/DashboardChart/DashboardChart";
import InfoTopBar from "../../components/common/InfoTopBar/InfoTopBar";
import SideBarWrapper from "../../components/common/sidebarWrapper";
import LoginSignUp from "../../components/common/LoginSignUp/LoginSignUp";
import ActiveAsset from "../../components/Wallet/ActiveAsset/ActiveAsset";
import ExploreAssets from "../../components/Wallet/ExploreAssets";
import YourAssets from "../../components/Wallet/YourAssets";

import styles from "../../styles/WalletPage.module.scss";
import InternalTransfer from "../../components/Modals/InternalTransfer/InternalTransfer";
export default function WalletPage() {
  const [activeIndex, setActiveIndex] = useState(-1);
  const [IsOpenInternalTransfer, setIsOpenInternalTransfer] = useState(false);

  const toggleInternalTransfer = () => {
    setIsOpenInternalTransfer(!IsOpenInternalTransfer);
  };
  const handleActive = (index) => {
    setActiveIndex(index);
  };
  return (
    <SideBarWrapper>
      <div className={styles.wrapper}>
        <InfoTopBar showDivider={false}>
         {/*  <LoginSignUp />*/}
        </InfoTopBar>

        <div className={styles.topSection}>
          <DashboardChart />
          <div className={styles.buttonsRow}>
            <div className={styles.buttonWrapper}>
              <Link to="/wallet/deposit">
                <button>Deposit</button>
              </Link>
            </div>
            <div className={styles.buttonWrapper}>
              <Link to="/wallet/withdrawal">
                <button>Withdrawal</button>
              </Link>
            </div>
            <div
              className={styles.buttonWrapper}
              onClick={toggleInternalTransfer}
            >
              <button>Internal Transfer</button>
            </div>
          </div>
        </div>
        <div className={styles.bottomSection}>
          <div className={styles.yourAssetsWrapper}>
            <div className={styles.infoBarWrapper}>
              <InfoTopBar
                heading="Your Assets"
                info="You currently own following assets."
              />
            </div>
            <YourAssets handleActive={handleActive} activeIndex={activeIndex} />
          </div>
          <div className={styles.exploreWrapper}>
            <div className={styles.infoBarWrapper}>
              {activeIndex === -1 && (
                <InfoTopBar
                  heading="Explore Assets"
                  info="Explore assets & add to your portfolio. "
                />
              )}
              {activeIndex >= 0 && (
                <InfoTopBar>
                  <button
                    style={{
                      all: "unset",
                      color: "#7137f9",
                      cursor: "pointer",
                    }}
                    onClick={() => handleActive(-1)}
                  >
                    <img
                      src={"/assets/backspace.svg"}
                      width="22px"
                      height="15px"
                      alt="Picture of the author"
                    />
                    <span style={{ marginLeft: "10px" }}>Add Assets</span>
                  </button>
                </InfoTopBar>
              )}
            </div>
            {activeIndex >= 0 ? <ActiveAsset /> : <ExploreAssets />}
            {/* <ExploreAssets /> */}
          </div>
        </div>
      </div>
      <InternalTransfer
        isOpen={IsOpenInternalTransfer}
        toggle={toggleInternalTransfer}
      />
    </SideBarWrapper>
  );
}
